import { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useLoadingAction from './store/useLoadingAction'
import useLoadingStore from './store/useLoadingStore'

const useLoading = () => {
    const loadTiming = useRef<any>()
    const loadingAction = useLoadingAction()
    const loadingStore = useLoadingStore()
    const location = useLocation()

    useEffect(() => {
        return () => {
            if (loadTiming.current) {
                clearTimeout(loadTiming.current)
                loadTiming.current = null
            }
        }
    }, [])

    const loadingOpen = () => {
        document.getElementsByTagName('body')[0].style.cursor = 'wait'
        if (loadTiming.current) clearTimeout(loadTiming.current)
        if (!loadingStore.isLoading) {
            loadingAction.openLoading()
        }
    }

    const loadingClose = () => {
        const windowSplit = window.location.href.split('/manage-project')?.[1] === ''
        const isComing = location.pathname.indexOf('/manage-project/') > -1
        const curr = document.getElementsByTagName('body')[0].style.cursor

        if (windowSplit && isComing && curr === 'default') {
            return
        }

        document.getElementsByTagName('body')[0].style.cursor = 'default'
        loadTiming.current = setTimeout(() => {
            loadingAction.closeLoading()
        }, 1000)
    }

    const clearLoading = () => {
        document.getElementsByTagName('body')[0].style.cursor = 'default'
        loadingAction.closeLoading()
    }

    return {
        configLoading: { isShowLoading: loadingStore.isLoading },
        loadingOpen,
        loadingClose,
        clearLoading,
    }
}

export default useLoading
